import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { deleteSubCategory, getAllSubCategories } from "../../../../../api/subCategoryAPIs";
import {
    BlockBetween,
    BlockContent,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    PreviewCard,
    ReactDataTable,
} from "../../../../../components/Component";
import DeleteModal from "../../../../../components/DeleteModal";
import Content from "../../../../../layout/content/Content";
import Head from "../../../../../layout/head/Head";

const SubCategoryList = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
    const [itemToDelete, setItemToDelete] = useState(null); // Store item to delete
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                setLoading(true);
                const response = await getAllSubCategories({ parentCategoryId: id });
                setCategories(response.data.data);
                console.log(response.data.data);

            } catch (error) {
                console.error("Failed to fetch categories:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            cell: (row) => (
                <div className="d-flex align-items-center m-1">
                    <img
                        src={row.images?.[0] || "https://via.placeholder.com/50"}
                        alt={row.name}
                        style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }}
                        className="me-2"
                    />
                    <span className="fw-bold text-dark">{row.name}</span>
                </div>
            ),
        },
        {
            name: "Description",
            selector: (row) => row.description,
            sortable: true,
            cell: (row) => (
                <div className="text-muted text-truncate" style={{ maxWidth: "250px" }} title={row.description}>
                    {row.description}
                </div>
            ),
        },
        {
            name: "Parent Category",
            selector: (row) => row.parentCategoryId?.name || "N/A",
            sortable: true,
            cell: (row) => (
                <span className="text-muted fst-italic">
                    {row.parentCategoryId?.name || "N/A"}
                </span>
            ),
        },
        {
            name: "Status",
            selector: (row) => (row.status ? "Active" : "Inactive"),
            sortable: true,
            cell: (row) => (
                <span
                    className={`badge rounded-pill px-3 py-1 ${row.status ? "bg-success" : "bg-danger"
                        }`}
                >
                    {row.status ? "Active" : "Inactive"}
                </span>
            ),
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="d-flex align-items-center gap-2">
                    <button
                        className="btn btn-sm btn-outline-primary d-flex align-items-center"
                        onClick={() => navigate(`/edit-sub-category/${id}/${row?._id}`)}
                    >
                        <i className="bi bi-pencil-fill me-1"></i>Edit
                    </button>
                    <button
                        className="btn btn-sm btn-outline-danger d-flex align-items-center"
                        onClick={() => {
                            setItemToDelete(row); // Set the item to delete
                            setIsModalOpen(true); // Open the modal
                        }}
                    >
                        <i className="bi bi-trash-fill me-1"></i>Delete
                    </button>
                </div >
            ),
        },
    ];

    const handleDelete = async (item) => {
        try {
            // Call API to delete category
            await deleteSubCategory({ subcategoryId: item._id, parentCategoryId: id });
            // After deletion, refresh the categories list
            setCategories(categories.filter((category) => category._id !== item._id));
            console.log("Sub Category deleted successfully");
            toast.success("Sub Category deleted successfully")
        } catch (error) {
            console.error("Error deleting category:", error);
            toast.error(error.response.message || "Error deleting category")
        }
    };

    return (
        <React.Fragment>
            <Head title="Sub Category List"></Head>
            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h3" page>
                                Sub Category List
                            </BlockTitle>
                            <BlockDes className="text-soft">
                                <p>You have a total of {categories.length} sub categories.</p>
                            </BlockDes>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <Button onClick={() => navigate(`/add-sub-category/${id}`)}>Add Sub Category</Button>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <BlockContent>
                    <PreviewCard>
                        <ReactDataTable
                            data={categories}
                            columns={columns}
                            progressPending={loading}
                            pagination
                        />
                    </PreviewCard>
                </BlockContent>
            </Content>
            <DeleteModal
                isOpen={isModalOpen}
                toggle={() => setIsModalOpen(!isModalOpen)}
                onConfirm={handleDelete}
                item={itemToDelete}
            />
        </React.Fragment>
    );
};

export default SubCategoryList;
